<ng-container>
  <div *ngIf="featuredRoles | async as displayRoles" class="grid guts-m-t-2">
    <div
      class="grid__col-sm-4"
      *ngFor="let role of displayRoles"
      data-dgat="role-select-items-74b"
    >
      <button
        (click)="onRoleSelected($event, role, displayRoles)"
        class="ib role-tile role-tile__wrapper role-tile--clickable"
        [attr.aria-pressed]="role.selected"
        data-dgat="role-select-items-ef5"
      >
        <dgx-role-tile [item]="role"> </dgx-role-tile>
      </button>
    </div>
  </div>
</ng-container>
